module.exports = __webpack_public_path__ + "static/media/measurments.84f978e9.jpg";